import React, { useState } from "react";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import TestimonialHome from "../components/testimonialhhome";

const statistics = [
  {
    title: "Accurate Valuation",
    text: "Get the right price for your property with our expert market analysis.",
    icon: "far fa-clipboard",
  },
  {
    title: "Smart Marketing",
    text: "Your property promoted across top portals, social media, and our network.",
    icon: "fas fa-bullhorn",
  },
  {
    title: "Qualified Buyers",
    text: "We connect you with serious, verified buyers to save your time.",
    icon: "fas fa-users",
  },
  {
    title: "Smooth Closing",
    text: "From negotiations to paperwork, we ensure a hassle-free selling experience.",
    icon: "far fa-handshake",
  },
];

const marketingAdvantages = [
  {
    image: "/images/a1.webp",
    icon: "fas fa-crosshairs",
    title: "Focused Attention",
    text: "Each of our agents manages a limited number of properties. This allows for stronger follow-up, better communication, and a higher level of service throughout the listing process.",
  },
  {
    image: "/images/a2.webp",
    icon: "far fa-building",
    title: "Every Property Matters",
    text: "We treat every property as unique. Each listing is handled with care, proper positioning, and a customized strategy designed to highlight its strengths.",
  },
  {
    icon: "fas fa-chart-line",
    title: "Strong Marketing Exposure",
    text: "We give your property maximum visibility across leading property portals and digital channels to reach the right audience faster.",
    bayut: "/images/logo/bayut1.png",
    pf: "/images/logo/property-finder1.png",
    dubizzle: "/images/logo/dubizzle1.png",
    websitelogo: "/images/logo/websitelogo.png",
    socialmedia: "/images/logo/socialmedia.png",
  },
  {
    image: "/images/a6.webp",
    icon: "fas fa-users",
    title: "Strong Client Database",
    text: "Our strong database of clients allows us to connect properties with active buyers and tenants more efficiently for better matching and faster exposure.",
  },
];

const sellingSteps = [
  {
    title: "Property consultation",
    text: "Tell us about your property, your expectations, and your preferred timeline.",
  },
  {
    title: "Fair market valuation",
    text: "We review market conditions, comparable properties, and recent transactions.",
  },
  {
    title: "Tailored marketing strategy",
    text: "Your listing is positioned and promoted across the channels most likely to reach qualified clients.",
  },
  {
    title: "Viewings and follow-up",
    text: "A specialized agent coordinates enquiries, viewings, communication, and ongoing feedback.",
  },
  {
    title: "Offer and completion",
    text: "We provide professional guidance through negotiation and the final property transaction.",
  },
];

function ListYourPropery() {
  const API = process.env.REACT_APP_API_URL || "https://nvrealestate.ae";
  const initialFormData = {
    agent_name: "",
    agent_lname: "",
    agent_phone: "",
    agent_email: "",
    agent_address: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({ text: "", type: "" });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
    setErrors((current) => ({ ...current, [name]: "" }));
  };

  const handlePhoneChange = (phone) => {
    setFormData((current) => ({ ...current, agent_phone: phone }));
    setErrors((current) => ({ ...current, agent_phone: "" }));
  };

  const validate = () => {
    const nextErrors = {};
    const phoneDigits = formData.agent_phone.replace(/\D/g, "");

    if (!formData.agent_name.trim()) nextErrors.agent_name = "First Name is required";
    if (!formData.agent_lname.trim()) nextErrors.agent_lname = "Last Name is required";
    if (!phoneDigits) nextErrors.agent_phone = "Phone number is required";
    else if (phoneDigits.length < 7 || phoneDigits.length > 15) {
      nextErrors.agent_phone = "Enter a valid phone number";
    }
    if (!formData.agent_email.trim()) nextErrors.agent_email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.agent_email)) {
      nextErrors.agent_email = "Enter a valid email address";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setResponse({ text: "", type: "" });
    if (!validate()) return;

    setLoading(true);
    try {
      const payload = {
        proref: "List Your Property",
        current_url: window.location.href,
        ...formData,
      };

      const result = await axios.post(
        `${API}/api/EnquiryHandlerStatic.ashx`,
        JSON.stringify(payload),
        { headers: { "Content-Type": "application/json" } }
      );

      setResponse({
        text: result.data?.message || "Message sent successfully!",
        type: "success",
      });
      setFormData(initialFormData);
      setErrors({});
    } catch (error) {
      setResponse({ text: "Something went wrong. Please try again.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .nv-sell-page {
          --sell-primary: #293e95;
          --sell-heading: #09256d;
          --sell-dark: #071634;
          --sell-gold: #c4934f;
          --sell-gold-soft: #f5ead7;
          --sell-ink: #151b2b;
          --sell-muted: #667085;
          --sell-border: #e1e6ef;
          --sell-soft: #f4f6fc;
          color: var(--sell-ink);
          background: #fff;
        }

        .nv-sell-shell {
          width: min(1380px, calc(100% - 32px));
          margin: 0 auto;
        }

        .nv-sell-hero {
          position: relative;
          min-height: 650px;
          overflow: hidden;
          color: var(--sell-ink);
          background:
            linear-gradient(110deg, #ffffff 0%, #ffffff 52%, transparent 52%),
            linear-gradient(135deg, #f7f9fd 0%, #edf2f8 100%);
        }

        .nv-sell-hero::before {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          width: 46%;
          background:radial-gradient(circle at 76% 22%, rgb(24 63 103 / 28%), transparent 28%), linear-gradient(135deg, #f4f6fc 0%, #c4d2fc 100%);
          clip-path: polygon(18% 0, 100% 0, 100% 100%, 0 100%);
          opacity: 1;
          pointer-events: none;
        }

        .nv-sell-hero::after {
          content: "";
          position: absolute;
          top: 0;
          right: 43%;
          bottom: 0;
          width: 9px;
          background: linear-gradient(180deg, #09256d, #09256d);
          transform: skewX(-14deg);
          transform-origin: bottom;
          z-index: 1;
        }

        .nv-sell-hero-layout {
          position: relative;
          z-index: 2;
          display: grid;
          grid-template-columns: minmax(440px, .9fr) minmax(420px, .72fr);
          align-items: center;
          gap: 72px;
          min-height: 650px;
          padding: 76px 0 122px;
        }

        .nv-sell-hero-copy {
          position: relative;
          max-width: 700px;
          margin: 0;
          text-align: left;
        }

        .nv-sell-eyebrow,
        .nv-sell-section-title > span,
        .nv-sell-copy > span {
          display: block;
          margin-bottom: 11px;
          color: #ffffff;
          font-size: 13px;
          font-weight: 800;
          letter-spacing: .16em;
          text-transform: uppercase;
        }

        .nv-sell-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          padding: 10px 18px;
          border: 1px solid #d9dfeb;
          border-radius: 999px;
          background: #fff;
          color: var(--sell-heading);
          box-shadow: 0 10px 28px rgba(24,35,68,.07);
        }

        .nv-sell-eyebrow::before {
          content: "";
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: var(--sell-gold);
          box-shadow: 0 0 0 4px rgba(196,147,79,.14);
        }

        .nv-sell-hero h1 {
          max-width: 620px;
          margin: 0 0 18px;
          color: var(--sell-heading);
          font-size: clamp(44px, 4.8vw, 72px);
          line-height: 1.04;
          letter-spacing: -.035em;
        }

        .nv-sell-hero h1 span { color: var(--sell-gold); }

        .nv-sell-hero p {
          max-width: 560px;
          margin: 0 0 31px;
          color: #4a5b80;
          font-size: 17px;
          line-height: 1.7;
        }

        .nv-sell-hero .nv-sell-actions { justify-content: flex-start; }

        .nv-sell-hero .nv-sell-btn.outline {
          border-color: #c8d0e8;
          background: #fff;
          color: var(--sell-primary);
        }

        .nv-sell-hero .nv-sell-btn.outline:hover {
          border-color: var(--sell-primary);
          background: var(--sell-primary);
          color: #fff;
        }

        .nv-sell-hero-benefits {
          display: inline-flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          gap: 12px;
          margin-top: 30px;
        }

        .nv-sell-hero-benefits span {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 10px 14px;
          border: 1px solid #dce2ec;
          border-radius: 999px;
          background: #fff;
          color: var(--sell-heading);
          font-size: 14px;
          font-weight: 700;
          box-shadow: 0 10px 24px rgba(24,35,68,.06);
        }

        .nv-sell-hero-benefits i {
          background: transparent;
          color: #09256d;
          font-size: 13px;
        }

        .nv-sell-hero-visual {
          position: relative;
          min-height: 460px;
          border-radius: 34px 0 0 34px;
        }

        .nv-sell-hero-image {
          position: absolute;
          inset: 24px 0 24px 18px;
          overflow: hidden;
          border: 1px solid rgba(255,255,255,.28);
          border-radius: 30px 0 0 30px;
          background: url("/images/a2.webp") center / cover no-repeat;
          box-shadow: 0 26px 70px rgba(0,0,0,.28);
        }

        .nv-sell-hero-image::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, transparent 62%, rgba(7,22,52,.22));
        }

        .nv-sell-hero-note {
          position: absolute;
          left: -28px;
          bottom: 54px;
          max-width: 310px;
          padding: 20px 22px;
          border-left: 4px solid #09256d;
          border-radius: 0 14px 14px 0;
          background: rgba(255,255,255,.96);
          color: var(--sell-heading);
          box-shadow: 0 18px 42px rgba(7,22,52,.18);
        }

        .nv-sell-hero-note strong {
          display: block;
          margin-bottom: 5px;
          font-size: 16px;
        }

        .nv-sell-hero-note span {
          display: block;
          color: #4a5b80;
          font-size: 12px;
          line-height: 1.5;
        }

        .nv-sell-hero-showcase {
          position: relative;
          align-self: center;
          min-height: 500px;
          isolation: isolate;
        }

        .nv-sell-hero-showcase::before {
          content: "";
          position: absolute;
          inset: 48px 20px 34px 42px;
          border: 1px solid rgba(255,255,255,.22);
          border-radius: 28px;
          background: rgba(255,255,255,.08);
          box-shadow: 0 24px 70px rgba(0,0,0,.22);
          backdrop-filter: blur(16px);
          z-index: 1;
          pointer-events: none;
        }

        .nv-sell-gallery-panel {
          position: absolute;
          overflow: hidden;
          top: 0;
          right: 0;
          width: min(330px, 58%);
          height: 238px;
          border: 1px solid rgba(255,255,255,.2);
          border-radius: 22px;
          background-position: center right;
          background-size: cover;
          box-shadow: 0 22px 50px rgba(0,0,0,.24);
          z-index: 3;
        }

        .nv-sell-gallery-panel::after {
          content: "";
          position: absolute;
          inset: 0;
          background:
            linear-gradient(90deg, rgba(7,22,52,.05), transparent 32%),
            linear-gradient(180deg, transparent 58%, rgba(7,22,52,.18));
        }

        .nv-sell-advantage-image.is-logo-panel {
          display: grid;
          place-items: center;
          background: linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%);
        }

        .nv-sell-advantage-image.is-logo-panel::before {
          content: "\\f201";
          width: 76px;
          height: 76px;
          display: grid;
          place-items: center;
          border-radius: 50%;
          background: #fff;
          color: var(--sell-primary);
          font-family: "Font Awesome 5 Free";
          font-size: 30px;
          font-weight: 900;
          box-shadow: 0 16px 38px rgba(41,62,149,.16);
        }

        .nv-sell-valuation-float {
          position: absolute;
          left: 0;
          bottom: 34px;
          width: min(380px, calc(100% - 74px));
          padding: 28px 30px 24px;
          border: 1px solid rgba(255,255,255,.22);
          border-radius: 20px;
          background: rgba(255,255,255,.94);
          color: var(--sell-ink);
          box-shadow: 0 24px 60px rgba(0,0,0,.26);
          backdrop-filter: blur(12px);
          z-index: 4;
        }

        .nv-sell-valuation-float-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 15px;
          margin-bottom: 17px;
        }

        .nv-sell-valuation-float-head > span {
          width: 45px;
          height: 45px;
          display: grid;
          place-items: center;
          border-radius: 50%;
          background: var(--sell-gold-soft);
          color: var(--sell-gold);
          font-size: 18px;
        }

        .nv-sell-valuation-float small {
          display: block;
          margin-bottom: 3px;
          color: var(--sell-gold);
          font-size: 11px;
          font-weight: 800;
          letter-spacing: .1em;
          text-transform: uppercase;
        }

        .nv-sell-valuation-float strong {
          display: block;
          color: var(--sell-heading);
          font-size: 22px;
          line-height: 1.25;
        }

        .nv-sell-market-bars {
          display: flex;
          align-items: end;
          gap: 7px;
          height: 50px;
          padding-top: 6px;
          border-bottom: 1px solid #dce2ec;
        }

        .nv-sell-market-bars span {
          flex: 1;
          border-radius: 3px 3px 0 0;
          background: #e3e7ef;
        }

        .nv-sell-market-bars span:nth-child(1) { height: 32%; }
        .nv-sell-market-bars span:nth-child(2) { height: 48%; }
        .nv-sell-market-bars span:nth-child(3) { height: 42%; }
        .nv-sell-market-bars span:nth-child(4) { height: 68%; }
        .nv-sell-market-bars span:nth-child(5) { height: 82%; background: #09256d; }

        .nv-sell-exposure-badge {
          position: absolute;
          top: 204px;
          right: 22px;
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 18px 22px;
          border: 1px solid rgba(255,255,255,.2);
          border-radius: 18px;
          background: rgba(7,22,52,.88);
          color: #fff;
          box-shadow: 0 18px 45px rgba(0,0,0,.27);
          backdrop-filter: blur(14px);
          z-index: 4;
        }

        .nv-sell-exposure-badge i {
          width: 52px;
          height: 52px;
          display: grid;
          place-items: center;
          border-radius: 50%;
          background: rgba(196,147,79,.22);
          color: #f1c989;
          font-size: 20px;
        }

        .nv-sell-exposure-badge strong {
          display: block;
          margin-bottom: 2px;
          font-size: 18px;
        }

        .nv-sell-exposure-badge span {
          display: block;
          color: rgba(255,255,255,.64);
          font-size: 13px;
        }

        .nv-sell-actions {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
        }

        .nv-sell-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          min-height: 50px;
          padding: 12px 22px;
          border: 1px solid var(--sell-primary);
          border-radius: 8px;
          background: #09256d;
          color: #fff;
          font-size: 13px;
          font-weight: 800;
          text-decoration: none;
          text-transform: uppercase;
          transition: .2s ease;
        }

        .nv-sell-btn:hover {
          transform: translateY(-2px);
          border-color: #071f49;
          background: #071f49;
          color: #fff;
        }

        .nv-sell-btn.outline {
          border-color: rgba(255,255,255,.68);
          background: rgba(255,255,255,.08);
        }

        .nv-sell-btn.outline:hover {
          border-color: #fff;
          background: #fff;
          color: var(--sell-primary);
        }

        .nv-sell-stats {
          position: relative;
          z-index: 3;
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          margin-top: -72px;
          overflow: hidden;
          border: 1px solid var(--sell-border);
          border-radius: 18px;
          background: rgba(255,255,255,.96);
          box-shadow: 0 18px 42px rgba(24,35,68,.13);
          backdrop-filter: blur(12px);
        }

        .nv-sell-stat {
          display: flex;
          align-items: center;
          gap: 20px;
          min-height: 126px;
          padding: 28px 30px;
          border-right: 1px solid var(--sell-border);
        }

        .nv-sell-stat:last-child { border-right: 0; }

        .nv-sell-stat-icon {
          flex: 0 0 52px;
          width: 52px;
          height: 52px;
          display: grid;
          place-items: center;
          border-radius: 50%;
          background: #09256d;
          color: var(--sell-gold);
          font-size: 22px;
        }

        .nv-sell-stat strong {
          display: block;
          margin-bottom: 7px;
          color: var(--sell-heading);
          font-size: 16px;
          line-height: 1.1;
        }

        .nv-sell-stat span {
          color: #2c395b;
          font-size: 13px;
          font-weight: 500;
          line-height: 1.4;
        }
.nv-sell-stat span i{
color:white;
      }
        .nv-sell-metrics-band {
          position: relative;
          margin-top: 0;
          background:
            radial-gradient(circle at 8% 50%, rgba(41,62,149,.5), transparent 34%),
            linear-gradient(135deg, #071f49 0%, #09256d 55%, #071634 100%);
          color: #fff;
        }

        .nv-sell-metrics {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr));
          min-height: 112px;
        }

        .nv-sell-metric {
          display: flex;
          align-items: center;
          gap: 18px;
          padding: 24px 42px;
          border-right: 1px solid rgba(255,255,255,.12);
        }

        .nv-sell-metric:last-child { border-right: 0; }

        .nv-sell-metric-icon {
          flex: 0 0 54px;
          width: 54px;
          height: 54px;
          display: grid;
          place-items: center;
          border-radius: 50%;
          background: linear-gradient(135deg, #e2bb75, #bd8842);
          color: #fff;
          font-size: 21px;
        }

        .nv-sell-metric strong {
          display: block;
          color: #fff;
          font-size: 28px;
          line-height: 1.1;
        }

        .nv-sell-metric span {
          display: block;
          margin-top: 4px;
          color: rgba(255,255,255,.82);
          font-size: 15px;
        }

        .nv-sell-section { padding: 86px 0; }
        .nv-sell-section.soft { background: var(--sell-soft); }

        .nv-sell-section-title {
          max-width: 780px;
          margin: 0 auto 40px;
          text-align: center;
        }

        .nv-sell-section-title > span,
        .nv-sell-copy > span { color: var(--sell-primary); }

        .nv-sell-section-title h2,
        .nv-sell-copy h2 {
          margin: 0 0 14px;
          color: var(--sell-heading);
          font-size: clamp(31px, 3.4vw, 44px);
          line-height: 1.2;
          letter-spacing: -.025em;
        }

        .nv-sell-section-title p,
        .nv-sell-copy > p {
          margin: 0;
          color: #4a5b80;
          font-size: 15px;
          line-height: 1.75;
        }

        .nv-sell-advantages {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 22px;
        }

        .nv-sell-advantage {
          display: grid;
          grid-template-columns: 190px 1fr;
          min-height: 225px;
          overflow: hidden;
          border: 1px solid var(--sell-border);
          border-radius: 12px;
          background: #fff;
          box-shadow: 0 12px 34px rgba(24,35,68,.07);
        }

        .nv-sell-advantage-image {
          min-height: 100%;
          background-position: center;
          background-size: cover;
        }

        .nv-sell-advantage-copy { padding: 27px 25px; }

        .nv-sell-small-icon {
          width: 44px;
          height: 44px;
          display: grid;
          place-items: center;
          margin-bottom: 16px;
          border-radius: 50%;
          background: #edf0ff;
          color: var(--sell-primary);
          font-size: 17px;
        }

        .nv-sell-advantage h3 {
          margin: 0 0 9px;
          color: var(--sell-heading);
          font-size: 20px;
          line-height: 1.3;
        }

        .nv-sell-advantage p {
          margin: 0;
          color: var(--sell-muted);
          font-size: 12px;
          line-height: 1.65;
        }

        .nv-sell-split {
          display: grid;
          grid-template-columns: 1fr 1fr;
          align-items: center;
          gap: 54px;
        }

        .nv-sell-valuation-image {
          position: relative;
          min-height: 500px;
          overflow: hidden;
          border-radius: 12px;
          background:
            linear-gradient(180deg, rgba(7,22,52,.06), rgba(7,22,52,.44)),
            url("/images/a3.webp") center / cover no-repeat;
          box-shadow: 0 18px 42px rgba(24,35,68,.14);
        }

        .nv-sell-valuation-card {
          position: absolute;
          right: 22px;
          bottom: 22px;
          left: 22px;
          padding: 21px;
          border-radius: 9px;
          background: rgba(255,255,255,.96);
          box-shadow: 0 12px 28px rgba(7,22,52,.18);
        }

        .nv-sell-valuation-card strong {
          display: block;
          margin-bottom: 6px;
          color: var(--sell-heading);
          font-size: 19px;
        }

        .nv-sell-valuation-card span {
          color: var(--sell-muted);
          font-size: 12px;
          line-height: 1.55;
        }

        .nv-sell-checks {
          display: grid;
          gap: 13px;
          margin: 25px 0 29px;
          padding: 0;
          list-style: none;
        }

        .nv-sell-checks li {
          display: flex;
          align-items: center;
          gap: 11px;
          color: #30394b;
          font-size: 13px;
        }

        .nv-sell-checks i {
          color: var(--sell-primary);
          font-size: 16px;
        }

        .nv-sell-process {
          position: relative;
          display: grid;
          grid-template-columns: repeat(5, minmax(0, 1fr));
          gap: 15px;
        }

        .nv-sell-process::before {
          content: "";
          position: absolute;
          top: 34px;
          right: 9%;
          left: 9%;
          height: 2px;
          background: #dce2f7;
        }

        .nv-sell-step {
          position: relative;
          z-index: 1;
          text-align: center;
        }

        .nv-sell-step-number {
          width: 68px;
          height: 68px;
          display: grid;
          place-items: center;
          margin: 0 auto 20px;
          border: 7px solid var(--sell-soft);
          border-radius: 50%;
          background: var(--sell-primary);
          color: #fff;
          font-size: 17px;
          font-weight: 900;
          box-shadow: 0 8px 20px rgba(41,62,149,.22);
        }

        .nv-sell-step h3 {
          margin: 0 0 9px;
          color: var(--sell-heading);
          font-size: 16px;
          line-height: 1.35;
        }

        .nv-sell-step p {
          margin: 0;
          color: var(--sell-muted);
          font-size: 11px;
          line-height: 1.6;
        }

        .nv-sell-lead {
          display: grid;
          grid-template-columns: .88fr 1.12fr;
          overflow: hidden;
          border-radius: 14px;
          background: #fff;
          box-shadow: 0 20px 48px rgba(24,35,68,.12);
        }

        .nv-sell-lead-copy {
          position: relative;
          padding: 47px 42px;
          overflow: hidden;
          color: #fff;
          background:
            linear-gradient(145deg, rgba(5,18,46,.98), rgba(41,62,149,.92)),
            url("/assets/images/why.jpg") center / cover no-repeat;
        }

        .nv-sell-lead-copy::after {
          content: "";
          position: absolute;
          right: -80px;
          bottom: -100px;
          width: 270px;
          height: 270px;
          border: 1px solid rgba(255,255,255,.1);
          border-radius: 50%;
        }

        .nv-sell-lead-copy > * { position: relative; z-index: 1; }

        .nv-sell-lead-copy span {
          display: block;
          margin-bottom: 10px;
          color: #ffffff;
          font-size: 12px;
          font-weight: 800;
          letter-spacing: .14em;
          text-transform: uppercase;
        }

        .nv-sell-lead-copy h2 {
          margin: 0 0 14px;
          color: #fff;
          font-size: 34px;
          line-height: 1.2;
        }

        .nv-sell-lead-copy p {
          margin: 0 0 28px;
          color: rgba(255,255,255,.78);
          font-size: 14px;
          line-height: 1.7;
        }

        .nv-sell-contact-list {
          display: grid;
          gap: 12px;
          margin: 0;
          padding: 0;
          list-style: none;
        }

        .nv-sell-contact-list a {
          display: flex;
          align-items: center;
          gap: 11px;
          color: #fff;
          font-size: 13px;
          text-decoration: none;
        }

        .nv-sell-contact-list i {
          width: 35px;
          height: 35px;
          display: grid;
          place-items: center;
          border: 1px solid rgba(255,255,255,.25);
          border-radius: 50%;
        }

        .nv-sell-form-wrap { padding: 42px; }

        .nv-sell-form-wrap h3 {
          margin: 0 0 7px;
          color: var(--sell-heading);
          font-size: 25px;
        }

        .nv-sell-form-wrap > p {
          margin: 0 0 25px;
          color: var(--sell-muted);
          font-size: 13px;
        }

        .nv-sell-form {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 16px 18px;
        }

        .nv-sell-field { min-width: 0; }
        .nv-sell-field.full { grid-column: 1 / -1; }

        .nv-sell-field label {
          display: block;
          margin-bottom: 7px;
          color: #293143;
          font-size: 12px;
          font-weight: 700;
        }

        .nv-sell-field input,
        .nv-sell-field textarea,
        .nv-sell-field .phone-input {
          width: 100% !important;
          min-height: 49px;
          padding: 11px 13px;
          border: 1px solid #d6dce7 !important;
          border-radius: 7px !important;
          background: #fff;
          color: var(--sell-ink);
          font-size: 13px;
          outline: none;
          box-shadow: none !important;
        }

        .nv-sell-field .react-tel-input .form-control { padding-left: 48px; }

        .nv-sell-field .react-tel-input .flag-dropdown {
          border: 1px solid #d6dce7;
          border-radius: 7px 0 0 7px;
          background: #f7f8fb;
        }

        .nv-sell-field textarea { min-height: 100px; resize: vertical; }

        .nv-sell-field input:focus,
        .nv-sell-field textarea:focus {
          border-color: var(--sell-primary) !important;
          box-shadow: 0 0 0 3px rgba(41,62,149,.1) !important;
        }

        .nv-sell-field .input-error { border-color: #d92d20 !important; }

        .nv-sell-error {
          margin: 5px 0 0;
          color: #d92d20;
          font-size: 11px;
        }

        .nv-sell-response {
          grid-column: 1 / -1;
          margin: 0;
          padding: 11px 13px;
          border-radius: 6px;
          font-size: 12px;
        }

        .nv-sell-response.success { background: #ecfdf3; color: #027a48; }
        .nv-sell-response.error { background: #fef3f2; color: #b42318; }
        .nv-sell-submit { grid-column: 1 / -1; width: 100%; border: 0; cursor: pointer; }
        .nv-sell-submit:disabled { cursor: wait; opacity: .7; }

        .nv-sell-trust-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 28px;
          align-items: center;
          margin-bottom: 44px;
        }

        .nv-sell-trust-card {
          display: grid;
          grid-template-columns: 190px 1fr;
          overflow: hidden;
          border: 1px solid var(--sell-border);
          border-radius: 12px;
          background: #fff;
          box-shadow: 0 12px 34px rgba(24,35,68,.07);
        }

        .nv-sell-trust-card img {
          width: 100%;
          height: 100%;
          min-height: 250px;
          object-fit: cover;
        }

        .nv-sell-trust-copy { padding: 29px 26px; }

        .nv-sell-trust-copy h3 {
          margin: 0 0 10px;
          color: var(--sell-heading);
          font-size: 22px;
        }

        .nv-sell-trust-copy p {
          margin: 0;
          color: var(--sell-muted);
          font-size: 13px;
          line-height: 1.7;
        }

        .nv-sell-review-wrap .wrap-categories-sw { margin-bottom: 0; }

        .nv-sell-final {
          padding: 64px 0;
          color: #fff;
          background:
            linear-gradient(90deg, rgba(5,18,46,.98), rgba(9,28,68,.9)),
            url("/assets/images/why.jpg") center / cover no-repeat;
        }

        .nv-sell-final-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 36px;
        }

        .nv-sell-final h2 {
          margin: 0 0 9px;
          color: #fff;
          font-size: 33px;
        }

        .nv-sell-final p {
          max-width: 660px;
          margin: 0;
          color: rgba(255,255,255,.78);
          font-size: 14px;
          line-height: 1.65;
        }

        @media (max-width: 1050px) {
          .nv-sell-hero {
            background: linear-gradient(180deg, #ffffff 0%, #f7f9fd 100%);
          }
          .nv-sell-hero::before,
          .nv-sell-hero::after {
            display: none;
          }
          .nv-sell-hero-layout {
            grid-template-columns: 1fr;
            gap: 34px;
            padding: 92px 0 78px;
          }
          .nv-sell-hero-copy {
            max-width: 760px;
            text-align: center;
            margin: 0 auto;
          }
          .nv-sell-hero h1,
          .nv-sell-hero p {
            margin-left: auto;
            margin-right: auto;
          }
          .nv-sell-hero .nv-sell-actions,
          .nv-sell-hero-benefits {
            justify-content: center;
          }
          .nv-sell-hero-visual {
            width: min(760px, 100%);
            min-height: 390px;
            margin: 0 auto;
          }
          .nv-sell-hero-image {
            inset: 0;
            border-radius: 24px;
          }
          .nv-sell-hero-note {
            left: 24px;
            bottom: 24px;
            border-radius: 0 14px 14px 0;
          }
          .nv-sell-stats { grid-template-columns: repeat(2, 1fr); }
          .nv-sell-stat:nth-child(2) { border-right: 0; }
          .nv-sell-stat:nth-child(-n+2) { border-bottom: 1px solid var(--sell-border); }
          .nv-sell-metrics { grid-template-columns: repeat(2, minmax(0, 1fr)); }
          .nv-sell-metric:nth-child(2) { border-right: 0; }
          .nv-sell-metric:nth-child(-n+2) { border-bottom: 1px solid rgba(255,255,255,.12); }
          .nv-sell-advantages { grid-template-columns: 1fr; }
          .nv-sell-process { grid-template-columns: repeat(3, 1fr); row-gap: 32px; }
          .nv-sell-process::before { display: none; }
          .nv-sell-lead { grid-template-columns: 1fr; }
        }

        @media (max-width: 780px) {
          .nv-sell-hero { min-height: auto; }
          .nv-sell-hero-layout {
            min-height: auto;
            padding: 86px 0 58px;
          }
          .nv-sell-hero-copy { margin: 0 auto; }
          .nv-sell-hero-visual { min-height: 330px; }
          .nv-sell-hero-note {
            right: 18px;
            left: 18px;
            max-width: none;
          }
          .nv-sell-stats { margin-top: -52px; }
          .nv-sell-stat {
            min-height: 116px;
            padding: 24px;
          }
          .nv-sell-metric {
            padding: 22px 26px;
          }
          .nv-sell-section { padding: 68px 0; }
          .nv-sell-split, .nv-sell-trust-grid { grid-template-columns: 1fr; }
          .nv-sell-valuation-image { min-height: 410px; }
          .nv-sell-process { grid-template-columns: repeat(2, 1fr); }
          .nv-sell-final-inner { align-items: flex-start; flex-direction: column; }
        }

        @media (max-width: 560px) {
          .nv-sell-shell { width: min(100% - 22px, 1180px); }
          .nv-sell-hero h1 { font-size: 38px; }
          .nv-sell-hero-layout { padding-top: 78px; }
          .nv-sell-hero-benefits {
            width: 100%;
            gap: 8px 14px;
          }
          .nv-sell-hero-visual { min-height: 285px; }
          .nv-sell-hero-note {
            position: relative;
            right: auto;
            bottom: auto;
            left: auto;
            margin-top: 14px;
            border-radius: 10px;
          }
          .nv-sell-hero-image {
            position: relative;
            height: 245px;
          }
          .nv-sell-actions { flex-direction: column; width: 100%; }
          .nv-sell-actions .nv-sell-btn { width: 100%; }
          .nv-sell-stats { grid-template-columns: 1fr; margin-top: -45px; }
          .nv-sell-stat { border-right: 0; border-bottom: 1px solid var(--sell-border); }
          .nv-sell-stat:last-child { border-bottom: 0; }
          .nv-sell-metrics { grid-template-columns: 1fr; }
          .nv-sell-metric,
          .nv-sell-metric:nth-child(2) {
            border-right: 0;
            border-bottom: 1px solid rgba(255,255,255,.12);
          }
          .nv-sell-metric:last-child { border-bottom: 0; }
          .nv-sell-advantage, .nv-sell-trust-card { grid-template-columns: 1fr; }
          .nv-sell-advantage-image { min-height: 210px; }
          .nv-sell-process, .nv-sell-form { grid-template-columns: 1fr; }
          .nv-sell-field.full, .nv-sell-response, .nv-sell-submit { grid-column: auto; }
          .nv-sell-lead-copy, .nv-sell-form-wrap { padding: 31px 22px; }
        }
      `}</style>

      <main className="nv-sell-page">
        <section className="nv-sell-hero">
          <div className="nv-sell-shell nv-sell-hero-layout">
            <div className="nv-sell-hero-copy"> 
              <h1>
                Sell Your Property with Confidence
              </h1>
              <p>
                A select approach built around fair valuation, focused attention,
                tailored marketing, and professional guidance from listing to completion.
              </p>
              <div className="nv-sell-actions">
                <a className="nv-sell-btn" href="#property-valuation">
                  <i className="fas fa-chart-line" /> Get a Free Valuation
                </a>
                <a
                  className="nv-sell-btn outline"
                  href="https://wa.me/971501577822"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-whatsapp" /> Speak to an Agent
                </a>
              </div>
              <div className="nv-sell-hero-benefits" aria-label="Property selling benefits">
                <span><i className="fas fa-check-circle" /> Free valuation</span>
                <span><i className="fas fa-check-circle" /> Tailored strategy</span>
                <span><i className="fas fa-check-circle" /> Qualified clients</span>
              </div>
            </div>

            <div className="nv-sell-hero-visual" aria-label="Luxury property selling presentation">
              <div className="nv-sell-hero-image" role="img" aria-label="Luxury residential property interior" />
              <div className="nv-sell-hero-note">
                <strong>Focused selling strategy</strong>
                <span>Valuation, positioning, marketing, and negotiation handled with one clear plan.</span>
              </div>
            </div>
          </div>
        </section>

        <div className="nv-sell-shell">
          <section className="nv-sell-stats" aria-label="Why property owners choose us">
            {statistics.map((stat) => (
              <article className="nv-sell-stat" key={stat.title}>
                <span className="nv-sell-stat-icon"><i className={stat.icon} /></span>
                <div>
                  <strong>{stat.title}</strong>
                  <span>{stat.text}</span>
                </div>
              </article>
            ))}
          </section>
        </div>
 

        <section className="nv-sell-section">
          <div className="nv-sell-shell">
            <header className="nv-sell-section-title">
              <span>Why choose us</span>
              <h2>A select approach focused on quality over quantity</h2>
              <p>
                Exceptional service does not come from handling the highest number
                of listings. It comes from giving each property the time, attention,
                and strategy it truly deserves.
              </p>
            </header>

            <div className="nv-sell-advantages">
              {marketingAdvantages.map((advantage) => (
                <article className="nv-sell-advantage" key={advantage.title}>
                  <div
                    className={`nv-sell-advantage-image ${advantage.image ? "" : "is-logo-panel"}`}
                    style={advantage.image ? { backgroundImage: `url(${advantage.image})` } : undefined}
                    role="img"
                    aria-label={advantage.title}
                  />
                  <div className="nv-sell-advantage-copy">
                    <span className="nv-sell-small-icon"><i className={advantage.icon} /></span>
                    <h3>{advantage.title}</h3>
                    <p>{advantage.text}</p>
                           {advantage.title === "Strong Marketing Exposure" && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 5,
            flexWrap: "wrap",
            marginTop: 15,
          }}
        >
          <img src={advantage.bayut} alt="Bayut" style={{ width: 63 }} />
          <img src={advantage.pf} alt="Property Finder" style={{ width: 63 }} />
          <img src={advantage.dubizzle} alt="Dubizzle" style={{ width: 63 }} />
          <img src={advantage.websitelogo} alt="Website" style={{ width: 63 }} />
          <img src={advantage.socialmedia} alt="Social Media" style={{ width: 63 }} />
        </div>
      )}

                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="nv-sell-section soft">
          <div className="nv-sell-shell nv-sell-split">
            <div className="nv-sell-valuation-image">
              <div className="nv-sell-valuation-card">
                <strong>Fair valuation. Real market knowledge.</strong>
                <span>A pricing recommendation shaped by evidence, not guesswork.</span>
              </div>
            </div>
            <div className="nv-sell-copy">
              <span>Property valuation</span>
              <h2>Price your property for today’s market</h2>
              <p>
                Our valuation process is based on fairness, accuracy, and real
                market knowledge. We assess market conditions, comparable
                properties, and recent transactions.
              </p>
              <ul className="nv-sell-checks">
                <li><i className="fas fa-check-circle" /> Current market conditions</li>
                <li><i className="fas fa-check-circle" /> Comparable property analysis</li>
                <li><i className="fas fa-check-circle" /> Recent transaction review</li>
                <li><i className="fas fa-check-circle" /> Clear positioning recommendation</li>
              </ul>
              <a className="nv-sell-btn" href="#property-valuation">
                Request Your Valuation
              </a>
            </div>
          </div>
        </section>

        <section className="nv-sell-section">
          <div className="nv-sell-shell">
            <header className="nv-sell-section-title">
              <span>Selling guide</span>
              <h2>A clear process from valuation to completion</h2>
              <p>
                Our specialized team combines strategy, follow-up, and professional
                guidance to keep your property sale moving.
              </p>
            </header>
            <div className="nv-sell-process">
              {sellingSteps.map((step, index) => (
                <article className="nv-sell-step" key={step.title}>
                  <span className="nv-sell-step-number">0{index + 1}</span>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="nv-sell-section soft" id="property-valuation">
          <div className="nv-sell-shell">
            <div className="nv-sell-lead">
              <div className="nv-sell-lead-copy">
                <span>Free consultation</span>
                <h2>Sell faster and at the best possible price</h2>
                <p>
                  Get a free property valuation and connect with expert agents who
                  will give your listing the focused attention it deserves.
                </p>
                <ul className="nv-sell-contact-list">
                  <li><a href="tel:+97126446368"><i className="fas fa-phone-alt" /> +971 2 644 6368</a></li>
                  <li><a href="tel:+971501577822"><i className="fas fa-mobile-alt" /> +971 50 157 7822</a></li>
                  <li><a href="mailto:info@nvrealestate.ae"><i className="far fa-envelope" /> info@nvrealestate.ae</a></li>
                </ul>
              </div>

              <div className="nv-sell-form-wrap">
                <h3>List Your Property</h3>
                <p>Share your details and our property team will contact you shortly.</p>
                <form className="nv-sell-form" onSubmit={handleSubmit} noValidate>
                  <div className="nv-sell-field">
                    <label htmlFor="sell-first-name">First Name *</label>
                    <input
                      id="sell-first-name"
                      name="agent_name"
                      value={formData.agent_name}
                      onChange={handleChange}
                      placeholder="Enter first name"
                      className={errors.agent_name ? "input-error" : ""}
                    />
                    {errors.agent_name && <p className="nv-sell-error">{errors.agent_name}</p>}
                  </div>

                  <div className="nv-sell-field">
                    <label htmlFor="sell-last-name">Last Name *</label>
                    <input
                      id="sell-last-name"
                      name="agent_lname"
                      value={formData.agent_lname}
                      onChange={handleChange}
                      placeholder="Enter last name"
                      className={errors.agent_lname ? "input-error" : ""}
                    />
                    {errors.agent_lname && <p className="nv-sell-error">{errors.agent_lname}</p>}
                  </div>

                  <div className="nv-sell-field">
                    <label htmlFor="sell-phone">Phone Number *</label>
                    <PhoneInput
                      country="ae"
                      value={formData.agent_phone}
                      onChange={handlePhoneChange}
                      inputClass={`phone-input ${errors.agent_phone ? "input-error" : ""}`}
                      containerClass="phone-container"
                      enableSearch
                      inputProps={{ id: "sell-phone" }}
                      placeholder="Enter phone number"
                    />
                    {errors.agent_phone && <p className="nv-sell-error">{errors.agent_phone}</p>}
                  </div>

                  <div className="nv-sell-field">
                    <label htmlFor="sell-email">Email Address *</label>
                    <input
                      id="sell-email"
                      type="email"
                      name="agent_email"
                      value={formData.agent_email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      className={errors.agent_email ? "input-error" : ""}
                    />
                    {errors.agent_email && <p className="nv-sell-error">{errors.agent_email}</p>}
                  </div>

                  <div className="nv-sell-field full">
                    <label htmlFor="sell-message">Property Details</label>
                    <textarea
                      id="sell-message"
                      name="agent_address"
                      value={formData.agent_address}
                      onChange={handleChange}
                      placeholder="Tell us about your property..."
                    />
                  </div>

                  {response.text && (
                    <p className={`nv-sell-response ${response.type}`} role="status">
                      {response.text}
                    </p>
                  )}

                  <button className="nv-sell-btn nv-sell-submit" type="submit" disabled={loading}>
                    {loading ? "Sending..." : "Get My Free Valuation"}
                    {!loading && <i className="fas fa-arrow-right" />}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="nv-sell-section">
          <div className="nv-sell-shell">
            <header className="nv-sell-section-title">
              <span>Trust and results</span>
              <h2>Professional representation backed by client trust</h2>
              <p>
                Strong reviews reflect our commitment to professionalism,
                transparency, communication, and quality service.
              </p>
            </header>

            <div className="nv-sell-trust-grid">
              <article className="nv-sell-trust-card">
                <img src="/images/a4.webp" alt="Nova Vision specialized property team" />
                <div className="nv-sell-trust-copy">
                  <span className="nv-sell-small-icon"><i className="fas fa-user-tie" /></span>
                  <h3>Specialized Team</h3>
                  <p>
                    Our team is experienced, knowledgeable, and specialized in the
                    market. Successful property representation requires strategy,
                    follow-up, and professional guidance.
                  </p>
                </div>
              </article>
              <article className="nv-sell-trust-card">
                <img src="/images/a7.webp" alt="Trusted property service" />
                <div className="nv-sell-trust-copy">
                  <span className="nv-sell-small-icon"><i className="fab fa-google" /></span>
                  <h3>Trusted by Clients</h3>
                  <p>
                    Our strong Google reviews reflect the trust our clients place
                    in us and show our commitment to professionalism, transparency,
                    and quality service.
                  </p>
                </div>
              </article>
            </div>

            <div className="nv-sell-review-wrap">
              <TestimonialHome />
            </div>
          </div>
        </section>

        <section className="nv-sell-final">
          <div className="nv-sell-shell nv-sell-final-inner">
            <div>
              <h2>Ready to list your property?</h2>
              <p>
                Start with a free valuation and discover how our select agency
                approach can position your property for stronger exposure and results.
              </p>
            </div>
            <div className="nv-sell-actions">
              <a className="nv-sell-btn" href="#property-valuation">
                List Your Property
              </a>
              <a
                className="nv-sell-btn outline"
                href="https://wa.me/971501577822"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-whatsapp" /> WhatsApp Us
              </a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default ListYourPropery;
